module.exports = {
	"_args": [
		[
			{
				"raw": "antd@^2.11.2",
				"scope": null,
				"escapedName": "antd",
				"name": "antd",
				"rawSpec": "^2.11.2",
				"spec": ">=2.11.2 <3.0.0",
				"type": "range"
			},
			"/Users/user/Desktop/similar-medication-search"
		]
	],
	"_from": "antd@>=2.11.2 <3.0.0",
	"_id": "antd@2.11.2",
	"_inCache": true,
	"_location": "/antd",
	"_nodeVersion": "6.10.0",
	"_npmOperationalInternal": {
		"host": "s3://npm-registry-packages",
		"tmp": "tmp/antd-2.11.2.tgz_1498374952249_0.21039797272533178"
	},
	"_npmUser": {
		"name": "raohai",
		"email": "surgesoft@gmail.com"
	},
	"_npmVersion": "3.10.10",
	"_phantomChildren": {},
	"_requested": {
		"raw": "antd@^2.11.2",
		"scope": null,
		"escapedName": "antd",
		"name": "antd",
		"rawSpec": "^2.11.2",
		"spec": ">=2.11.2 <3.0.0",
		"type": "range"
	},
	"_requiredBy": [
		"/"
	],
	"_resolved": "https://registry.npmjs.org/antd/-/antd-2.11.2.tgz",
	"_shasum": "7c39773e61b894d830b0548ff85c6dac07317618",
	"_shrinkwrap": null,
	"_spec": "antd@^2.11.2",
	"_where": "/Users/user/Desktop/similar-medication-search",
	"bugs": {
		"url": "https://github.com/ant-design/ant-design/issues"
	},
	"contributors": [
		{
			"name": "ant"
		}
	],
	"dependencies": {
		"array-tree-filter": "~1.0.0",
		"babel-runtime": "6.x",
		"classnames": "~2.2.0",
		"create-react-class": "^15.5.3",
		"css-animation": "^1.2.5",
		"dom-closest": "^0.2.0",
		"lodash.debounce": "^4.0.8",
		"moment": "^2.18.1",
		"object-assign": "~4.1.0",
		"omit.js": "^0.1.0",
		"prop-types": "^15.5.7",
		"rc-animate": "~2.3.6",
		"rc-calendar": "~8.4.1",
		"rc-cascader": "~0.11.3",
		"rc-checkbox": "~2.0.3",
		"rc-collapse": "~1.7.5",
		"rc-dialog": "~6.5.10",
		"rc-dropdown": "~1.4.11",
		"rc-editor-mention": "~0.6.12",
		"rc-form": "~1.4.0",
		"rc-input-number": "~3.6.0",
		"rc-menu": "~5.0.10",
		"rc-notification": "~2.0.0",
		"rc-pagination": "~1.9.4",
		"rc-progress": "~2.1.2",
		"rc-rate": "~2.1.1",
		"rc-select": "~6.8.6",
		"rc-slider": "~8.1.2",
		"rc-steps": "~2.5.1",
		"rc-switch": "~1.5.1",
		"rc-table": "~5.3.3",
		"rc-tabs": "~8.0.0",
		"rc-time-picker": "~2.4.1",
		"rc-tooltip": "~3.4.6",
		"rc-tree": "~1.5.0",
		"rc-tree-select": "~1.10.2",
		"rc-upload": "~2.3.7",
		"rc-util": "^4.0.4",
		"react-lazy-load": "^3.0.10",
		"react-slick": "~0.14.2",
		"shallowequal": "^1.0.1",
		"warning": "~3.0.0"
	},
	"description": "An enterprise-class UI design language and React-based implementation",
	"devDependencies": {
		"@types/react": "^15.0.8",
		"@types/react-dom": "~0.14.18",
		"antd-demo-jest": "^1.0.5",
		"antd-tools": "~1.5.0",
		"babel-cli": "^6.18.0",
		"babel-eslint": "^7.1.0",
		"babel-jest": "^19.0.0",
		"babel-plugin-import": "^1.0.0",
		"babel-plugin-transform-runtime": "^6.23.0",
		"babel-preset-es2015": "^6.18.0",
		"babel-preset-react": "^6.16.0",
		"babel-preset-stage-0": "^6.16.0",
		"bezier-easing": "^2.0.3",
		"bisheng": "^0.24.0",
		"bisheng-plugin-antd": "^0.15.0",
		"bisheng-plugin-description": "^0.1.1",
		"bisheng-plugin-react": "^0.5.0",
		"bisheng-plugin-toc": "^0.4.0",
		"color-standalone": "^0.11.6",
		"cross-env": "^4.0.0",
		"css-split-webpack-plugin": "^0.2.3",
		"dekko": "^0.2.0",
		"delegate": "^3.1.2",
		"dora-plugin-upload": "^0.3.1",
		"enquire.js": "^2.1.1",
		"enzyme": "^2.6.0",
		"enzyme-to-json": "^1.3.0",
		"eslint": "^3.0.1",
		"eslint-config-airbnb": "latest",
		"eslint-plugin-babel": "^4.0.0",
		"eslint-plugin-import": "^2.2.0",
		"eslint-plugin-jsx-a11y": "^5.0.1",
		"eslint-plugin-markdown": "~1.0.0-beta.4",
		"eslint-plugin-react": "^7.0.1",
		"eslint-tinker": "^0.4.0",
		"fetch-jsonp": "^1.0.3",
		"glob": "^7.1.1",
		"jest": "^19.0.2",
		"jsonml.js": "^0.1.0",
		"lint-staged": "^3.3.1",
		"mockdate": "^2.0.1",
		"moment-timezone": "^0.5.5",
		"pre-commit": "^1.2.2",
		"querystring": "^0.2.0",
		"rc-queue-anim": "^1.0.1",
		"rc-scroll-anim": "^1.0.3",
		"rc-tween-one": "^1.1.2",
		"react": "^15.0.0",
		"react-color": "^2.11.7",
		"react-copy-to-clipboard": "^4.0.1",
		"react-document-title": "^2.0.1",
		"react-dom": "^15.0.0",
		"react-github-button": "^0.1.1",
		"react-intl": "^2.0.1",
		"react-sublime-video": "^0.2.0",
		"react-test-renderer": "^15.5.4",
		"reqwest": "^2.0.5",
		"rimraf": "^2.5.4",
		"stylelint": "^7.8.0",
		"stylelint-config-standard": "^16.0.0",
		"typescript": "~2.3.0",
		"typescript-babel-jest": "^1.0.2",
		"values.js": "^1.0.3",
		"xhr2": "^0.1.3"
	},
	"directories": {},
	"dist": {
		"shasum": "7c39773e61b894d830b0548ff85c6dac07317618",
		"tarball": "https://registry.npmjs.org/antd/-/antd-2.11.2.tgz"
	},
	"files": [
		"dist",
		"lib",
		"es"
	],
	"gitHead": "890cca119bc9dc84d313bba5c08650c8e4fb8baf",
	"homepage": "http://ant.design/",
	"jest": {
		"setupFiles": [
			"./tests/setup.js"
		],
		"moduleFileExtensions": [
			"ts",
			"tsx",
			"js",
			"jsx",
			"json",
			"md"
		],
		"modulePathIgnorePatterns": [
			"/_site/"
		],
		"testPathIgnorePatterns": [
			"/node_modules/",
			"dekko",
			"node"
		],
		"transform": {
			"\\.tsx?$": "./node_modules/typescript-babel-jest",
			"\\.js$": "./node_modules/babel-jest",
			"\\.md$": "./node_modules/antd-demo-jest"
		},
		"testRegex": ".*\\.test\\.js$",
		"collectCoverageFrom": [
			"components/**/*.{ts,tsx}",
			"!components/*/style/index.tsx",
			"!components/style/index.tsx",
			"!components/*/locale/index.tsx"
		],
		"transformIgnorePatterns": [
			"/node_modules/",
			"/dist/"
		],
		"snapshotSerializers": [
			"enzyme-to-json/serializer"
		]
	},
	"keywords": [
		"ant",
		"design",
		"react",
		"react-component",
		"component",
		"components",
		"ui",
		"framework",
		"frontend"
	],
	"license": "MIT",
	"lint-staged": {
		"components/**/*.tsx": [
			"lint-staged:ts"
		],
		"{tests,site,scripts,components}/**/*.{js,jsx}": [
			"lint-staged:es"
		],
		"{site,components}/**/*.less": "stylelint --syntax less",
		"components/*/demo/*.md": [
			"lint-staged:demo"
		]
	},
	"main": "lib/index.js",
	"maintainers": [
		{
			"name": "benjycui",
			"email": "benjytrys@gmail.com"
		}
	],
	"module": "es/index.js",
	"name": "antd",
	"optionalDependencies": {},
	"pre-commit": [
		"lint-staged"
	],
	"readme": "<p align=\"center\">\n  <a href=\"http://ant.design\">\n    <img width=\"320\" src=\"https://t.alipayobjects.com/images/rmsweb/T1B9hfXcdvXXXXXXXX.svg\">\n  </a>\n</p>\n\n# Ant Design\n\n[![](https://img.shields.io/travis/ant-design/ant-design.svg?style=flat-square)](https://travis-ci.org/ant-design/ant-design)\n[![Codecov](https://img.shields.io/codecov/c/github/ant-design/ant-design/master.svg?style=flat-square)](https://codecov.io/gh/ant-design/ant-design/branch/master)\n[![Dependency Status](https://img.shields.io/gemnasium/react-component/trigger.svg?style=flat-square)](https://gemnasium.com/ant-design/ant-design)\n\n[![npm package](https://img.shields.io/npm/v/antd.svg?style=flat-square)](https://www.npmjs.org/package/antd)\n[![NPM downloads](http://img.shields.io/npm/dm/antd.svg?style=flat-square)](https://npmjs.org/package/antd)\n[![Percentage of issues still open](http://isitmaintained.com/badge/open/ant-design/ant-design.svg)](http://isitmaintained.com/project/ant-design/ant-design \"Percentage of issues still open\")\n[![Gitter](https://badges.gitter.im/ant-design/ant-design-english.svg)](https://gitter.im/ant-design/ant-design-english?utm_source=badge&utm_medium=badge&utm_campaign=pr-badge) (English)\n[![Join the chat at https://gitter.im/ant-design/ant-design](https://img.shields.io/gitter/room/ant-design/ant-design.svg?style=flat-square)](https://gitter.im/ant-design/ant-design?utm_source=badge&utm_medium=badge&utm_campaign=pr-badge&utm_content=badge)（中文）\n\nAn enterprise-class UI design language and React-based implementation.\n\n[中文 README](README-zh_CN.md)\n\n## Features\n\n- An enterprise-class UI design language for web applications.\n- A set of high-quality React components out of the box.\n- Written in TypeScript with complete define types.\n- A npm + webpack + [dva](https://github.com/dvajs/dva) front-end development workflow.\n\n## Environment Support\n\n* Modern browsers and Internet Explorer 9+ (with [polyfills](https://ant.design/docs/react/getting-started#Compatibility))\n* Server-side Rendering\n* [Electron](http://electron.atom.io/)\n\n## Let's build a better antd together [![PRs Welcome](https://img.shields.io/badge/PRs-welcome-brightgreen.svg?style=flat-square)](http://makeapullrequest.com)\n\n`antd` is an open source project, improvements are welcomed. If you are interested in contributing to `antd`, you can watch this repository, join in [discussion](https://github.com/ant-design/ant-design/issues?q=is%3Aopen+is%3Aissue+label%3ADiscussion), or try to implement some [features which have been accepted](https://github.com/ant-design/ant-design/issues?q=is%3Aopen+is%3Aissue+label%3A%22PR+welcome%22). Actually, there are [many ways](https://opensource.guide/how-to-contribute/) to contribute. And we are always happy to [offer collaborator permission](https://github.com/ant-design/ant-design/issues/3222) for some active contributors.\n\n## Install\n\n```bash\nnpm install antd\n```\n\n## Usage\n\n```jsx\nimport { DatePicker } from 'antd';\nReactDOM.render(<DatePicker />, mountNode);\n```\n\nAnd import style manually:\n\n```jsx\nimport 'antd/dist/antd.css';  // or 'antd/dist/antd.less'\n```\n\n### Use modularized antd\n\n- Use [babel-plugin-import](https://github.com/ant-design/babel-plugin-import) (Recommended)\n\n   ```js\n   // .babelrc or babel-loader option\n   {\n     \"plugins\": [\n       [\"import\", { libraryName: \"antd\", style: \"css\" }] // `style: true` for less\n     ]\n   }\n   ```\n\n   Then you can import components from antd, equivalent to import manually below.\n\n   ```jsx\n   // import js and css modularly, parsed by babel-plugin-import\n   import { DatePicker } from 'antd';\n   ```\n\n- Manually import\n\n   ```jsx\n   import DatePicker from 'antd/lib/date-picker';  // for js\n   import 'antd/lib/date-picker/style/css';        // for css\n   // import 'antd/lib/date-picker/style';         // that will import less\n   ```\n\n### TypeScript\n\n```js\n// tsconfig.json\n{\n  \"compilerOptions\": {\n    \"moduleResolution\": \"node\",\n    \"jsx\": \"preserve\",\n    \"allowSyntheticDefaultImports\": true\n  }\n}\n```\n\n> Note:\n> - set `allowSyntheticDefaultImports` to prevent `error TS1192: Module 'react' has no default export`.\n> - Don't use @types/antd, antd provide a built-in ts definition already.\n\n## Internationalization\n\nSee [i18n](http://ant.design/docs/react/i18n).\n\n## Links\n\n- [Home page](http://ant.design/)\n- [UI library](http://ant.design/docs/react/introduce)\n- [Change Log](CHANGELOG.en-US.md)\n- [Offcial Scaffold Tool](https://github.com/dvajs/dva-cli/)\n- [Development Tool](http://ant-tool.github.io/)\n- [Scaffold Market](http://scaffold.ant.design)\n- [rc-components](http://react-component.github.io/)\n- [Mobile UI](http://mobile.ant.design)\n- [Motion](https://motion.ant.design)\n- [Developer Instruction](https://github.com/ant-design/ant-design/wiki/Development)\n- [Versioning Release Note](https://github.com/ant-design/ant-design/wiki/%E8%BD%AE%E5%80%BC%E8%A7%84%E5%88%99%E5%92%8C%E7%89%88%E6%9C%AC%E5%8F%91%E5%B8%83%E6%B5%81%E7%A8%8B)\n- [FAQ](https://github.com/ant-design/ant-design/wiki/FAQ)\n- [CodePen boilerplate](http://codepen.io/benjycui/pen/KgPZrE?editors=001) for bug reports\n- [Awesome Ant Design](https://github.com/websemantics/awesome-ant-design)\n- [Customize Theme](http://ant.design/docs/react/customize-theme)\n\n## Development\n\n```bash\n$ git clone git@github.com:ant-design/ant-design.git\n$ npm install\n$ npm start\n```\n\nOpen your browser and visit http://127.0.0.1:8001 , see more at https://github.com/ant-design/ant-design/wiki/Development .\n\n## Contributing\n\nWe welcome all contributions, please read our [CONTRIBUTING.md](https://github.com/ant-design/ant-design/blob/master/.github/CONTRIBUTING.md) first. You can submit any ideas as [pull requests](https://github.com/ant-design/ant-design/pulls) or as [GitHub issues](https://github.com/ant-design/ant-design/issues). If you'd like to improve code, check out the [Development Instructions](https://github.com/ant-design/ant-design/wiki/Development) and have a good time! :)\n",
	"readmeFilename": "README.md",
	"repository": {
		"type": "git",
		"url": "git+https://github.com/ant-design/ant-design.git"
	},
	"scripts": {
		"authors": "git log --format='%aN <%aE>' | sort -u | grep -v 'users.noreply.github.com' | grep -v 'gitter.im' | grep -v '.local>' | grep -v 'alibaba-inc.com' | grep -v 'alipay.com' | grep -v 'taobao.com' > AUTHORS.txt",
		"compile": "antd-tools run compile",
		"deploy": "antd-tools run clean && npm run site && bisheng gh-pages --push-only",
		"dist": "antd-tools run dist",
		"lint": "npm run lint:ts && npm run lint:es && npm run lint:demo && npm run lint:style",
		"lint-fix": "npm run lint-fix:code && npm run lint-fix:demo",
		"lint-fix:code": "eslint --fix tests site scripts components ./.eslintrc.js ./webpack.config.js --ext '.js,.jsx'",
		"lint-fix:demo": "eslint-tinker ./components/*/demo/*.md",
		"lint-fix:ts": "npm run tsc && antd-tools run ts-lint-fix",
		"lint-staged": "lint-staged",
		"lint-staged:demo": "cross-env RUN_ENV=DEMO eslint --ext '.md'",
		"lint-staged:es": "eslint ./.eslintrc.js ./webpack.config.js",
		"lint-staged:ts": "tsc && node node_modules/tslint/bin/tslint -c node_modules/antd-tools/lib/tslint.json",
		"lint:demo": "cross-env RUN_ENV=DEMO eslint components/*/demo/*.md --ext '.md'",
		"lint:es": "eslint tests site scripts components ./.eslintrc.js ./webpack.config.js --ext '.js,.jsx'",
		"lint:style": "stylelint \"{site,components}/**/*.less\" --syntax less",
		"lint:ts": "npm run tsc && antd-tools run ts-lint",
		"pre-publish": "npm run test-all && node ./scripts/prepub",
		"prepublish": "antd-tools run guard",
		"pub": "antd-tools run pub",
		"site": "bisheng build --ssr -c ./site/bisheng.config.js",
		"start": "bisheng start -c ./site/bisheng.config.js --no-livereload",
		"test": "jest",
		"test-all": "./scripts/test-all.sh",
		"tsc": "tsc"
	},
	"title": "Ant Design",
	"typings": "lib/index.d.ts",
	"version": "2.11.2"
};


//////////////////
// WEBPACK FOOTER
// ./~/antd/package.json
// module id = 454
// module chunks = 0